import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-linkgroups",
  "use": "icon-linkgroups-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-linkgroups\">\n<g id=\"icon-linkgroups_icon\">\n<rect id=\"icon-linkgroups_Rectangle 8023\" width=\"36\" height=\"36\" rx=\"4\" fill=\"#E7F0F4\" />\n<path id=\"icon-linkgroups_Vector\" d=\"M18.0025 7C11.9532 7 7 11.9206 7 18.0012C7 24.0498 11.9187 29 18 29C24.0813 29 29 24.0818 29 18.0012C29.0025 11.9526 24.0837 7 18.0025 7V7ZM21.4458 21.1363C21.4458 21.3531 21.2685 21.5304 21.0517 21.5304H15.0074C14.7906 21.5304 14.6133 21.3531 14.6133 21.1363V15.0927C14.6133 14.876 14.7906 14.6986 15.0074 14.6986H21.0542C21.2709 14.6986 21.4483 14.876 21.4483 15.0927V21.1363H21.4458Z\" fill=\"#789CB9\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/linkgroups.svg
// module id = N/OE
// module chunks = 103